import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { meQuery } from "@/features/auth/session";
import { AppLayout, Unreachable } from "@/features/shell/AppLayout";

/**
 * The signed-in app. Everything under this route has a session, a running
 * sync engine, and the shell around it.
 *
 * `task` lives here, not on a page, so a task panel can open over any page —
 * the board, the inbox, someone's task list — and a link to a task works from
 * anywhere in the product.
 */
const SearchSchema = z.object({
  task: z.string().optional(),
});

export const Route = createFileRoute("/_app")({
  validateSearch: SearchSchema,
  beforeLoad: async ({ context, location }) => {
    const me = await context.queryClient.query({ ...meQuery, staleTime: "static" });
    if (!me) {
      throw redirect({ to: "/login", search: { returnTo: location.href } });
    }
    return { me };
  },
  component: AppLayout,
  errorComponent: Unreachable,
});
